import { PhoneInput } from 'components/phone-input';
import {
  FloatingFormLabel,
  FormControl,
  FormField,
  FormItem,
} from 'components/ui/form';
import type { ReactNode } from 'react';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { cn } from 'utils/tailwind';

type FormPhoneFieldProps<TFieldValues extends FieldValues = FieldValues> = {
  name: Path<TFieldValues>;
  control: Control<TFieldValues>;
  label: ReactNode;
  invalid?: boolean;
  disabled?: boolean;
  className?: string;
  containerClassName?: string;
} & Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'name' | 'className' | 'disabled' | 'type' | 'value'
>;

export const FormPhoneField = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  invalid,
  disabled,
  className,
  containerClassName,
}: FormPhoneFieldProps<TFieldValues>) => (
  <FormField
    control={control}
    name={name}
    render={({ field: { onChange, ...field } }) => (
      <FormItem className={cn('w-full', containerClassName)}>
        <FormControl>
          <div className="relative">
            <PhoneInput
              allowEmptyFormatting
              className={className}
              invalid={invalid}
              disabled={disabled}
              onValueChange={({ value }) => {
                onChange(value);
              }}
              {...field}
            />
            <FloatingFormLabel filled>{label}</FloatingFormLabel>
          </div>
        </FormControl>
      </FormItem>
    )}
  />
);
